'use strict';

require('tinymce');


// WEBPACK FOOTER //
// ./resources/assets/js/editor.js